export interface CapturedPhoto {
  id?: string;
  fileName: string;
  objectName?: string;
  file?: File;
  previewUrl: string;
  type?: string;
}

export interface PresignedUrlsPayload {
  orderId: string;
  type: EvidenceType;
  files: Array<{
    fileName: string;
  }>;
}

export interface ServiceOrderEvidencesPayload {
  type: EvidenceType;
  urls: string[];
  workOrderItemId?: string;
}

export enum EvidenceType {
  RECEPTION = 'RECEPTION',
  PROCESS = 'PROCESS',
  FINAL = 'FINAL',
  TECHNICAL_REVIEW = 'TECHNICAL_REVIEW',
  SIGNATURE = 'SIGNATURE',
  NEWS = 'NEWS',
}
